import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, Loader } from 'components/lib';

export default function ApproveOrder(){

    const [status, setStatus] = useState('loading');

    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (!token){
            setStatus('error');
            return;
        }

        async function approve(){
            try {
                await axios.get(`/api/orders/packageApprove?token=${token}`);
                setStatus('success');
            }
            catch(err){
                setStatus('error');
            }
        }

        approve();

    }, []);

    return (
        <div style={{ maxWidth: 480, margin: '80px auto' }}>

            <Card>

                {/* LOADING */}
                { status === 'loading' && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <Loader />
                        <h3 style={{ marginTop: 20 }}>Approving your order</h3>
                        <p style={{ color: '#6b7280' }}>
                            Please wait while we process your request...
                        </p>
                    </div>
                )}

                {/* SUCCESS */}
                { status === 'success' && (
                    <div style={{ textAlign: 'center', padding: '10px 20px' }}>

                        <div style={{
                            width: 60,
                            height: 60,
                            borderRadius: '50%',
                            background: '#ecfdf5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px'
                        }}>
                            <span style={{ fontSize: 28 }}>✔</span>
                        </div>

                        <h2 style={{ marginBottom: 10 }}>Order Package Approved</h2>

                        <p style={{ color: '#6b7280' }}>
                            Your order package has been successfully approved.
                        </p>

                        <p style={{ fontSize: 13, color: '#9ca3af', marginTop: 20 }}>
                            You can safely close this page.
                        </p>

                    </div>
                )}

                {/* ERROR */}
                { status === 'error' && (
                    <div style={{ textAlign: 'center', padding: '10px 20px' }}>

                        <div style={{
                            width: 60,
                            height: 60,
                            borderRadius: '50%',
                            background: '#fef2f2',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px'
                        }}>
                            <span style={{ fontSize: 28 }}>!</span>
                        </div>

                        <h2 style={{ marginBottom: 10 }}>Approval Failed</h2>

                        <p style={{ color: '#6b7280' }}>
                            This link is invalid or has expired.
                        </p>

                    </div>
                )}

            </Card>

        </div>
    );
}